import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultDestinationSummaryEvents = {
    onClick: noop
};

function useDestinationSummaryEvents(props) {
    const {
        destinationSummaryEvents: propsDestinationSummaryEvents
    } = props;

    const {
        events: destinationSummaryEvents
    } = useEvents(defaultDestinationSummaryEvents, propsDestinationSummaryEvents);

    const result = {
        destinationSummaryEvents
    };

    useDebugValue(result);

    return result;
}

export {useDestinationSummaryEvents};
